var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tournament)?_c('main',[(_vm.tournament.isRR())?_c('RoundRobin'):_vm._e(),([1,3].includes(_vm.tournament.type))?_c('Brackets'):_vm._e(),(_vm.tournament.isTFT())?_c('Tft'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }